import { ComponentProps } from 'react';
import { Inline } from '../../../../design-system/inline/inline';
import { DrawerNavigation } from '../../../../design-system/navigation/drawer-navigation';
import { PdfViewer } from '../../../../design-system/pdf-viewer/pdf-viewer';
import { Stack } from '../../../../design-system/stack/stack';
import { InvoiceDrawerContentBody } from './invoice-drawer-content-body';

type NavigationConfig =
  | { isVisible: false }
  | {
      isVisible: true;
      isFirstInvoice: boolean;
      isLastInvoice: boolean;
      onPrevious: () => void;
      onNext: () => void;
    };

type InvoiceDrawerContentProps = {
  invoiceVendor: string;
  pdfConfig: ComponentProps<typeof PdfViewer>;
  navigationConfig: NavigationConfig;
  contentBodyConfig: ComponentProps<typeof InvoiceDrawerContentBody>['contentBodyConfig'];
  onMarkNotInvoice: () => void;
};

export const InvoiceDrawerContent = ({
  invoiceVendor,
  pdfConfig,
  navigationConfig,
  contentBodyConfig,
  onMarkNotInvoice,
}: InvoiceDrawerContentProps) => {
  return (
    <Stack space={3} align="stretch" className="h-full py-7 pr-2 pl-7">
      <Inline space={3}>
        {navigationConfig.isVisible && <DrawerNavigation navigationConfig={navigationConfig} />}

        <p className="text-base leading-6 font-medium tracking-tight text-black">{invoiceVendor}</p>
      </Inline>

      <Stack space={3} align="stretch" className="h-full overflow-y-auto pr-4">
        <PdfViewer {...pdfConfig} isHeaderVisible={false} initialScale={1.8} className="h-[380px] shrink-0" />

        <InvoiceDrawerContentBody contentBodyConfig={contentBodyConfig} onMarkNotInvoice={onMarkNotInvoice} />
      </Stack>
    </Stack>
  );
};
